import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import AutoComplete from '../../input/select/AutoComplete';
import messages from './filterMessages';

class SelectFilter extends Component {
  state = {
    selectedItem: undefined,
  };

  componentDidMount() {
    const { initialValue } = this.props;
    if (initialValue) {
      this.setState(state => ({
        ...state,
        selectedItem: initialValue,
      }));
    }
  }

  handleClear() {
    const { onFilter } = this.props;

    this.setState(state => ({
      ...state,
      selectedItem: undefined,
    }));

    onFilter({ selectedItem: undefined });
  }

  selectedItemChanged(selectedItem) {
    if (!selectedItem) return;
    this.setState(state => ({
      ...state,
      selectedItem,
    }));
  }

  onClear() {
    this.setState(state => ({
      ...state,
      selectedItem: undefined,
    }));
  }

  render() {
    const { selectedItem } = this.state;
    const { onFilter, isFiltered, loadFunc, initialValue, intl } = this.props;

    return (
      <div>
        <AutoComplete
          loadFunc={loadFunc}
          onChange={item => this.selectedItemChanged(item)}
          initialSelectedItem={initialValue}
          onClear={() => this.onClear()}
          mode="edit"
        />
        <button
          type="button"
          className="btn btn-inverse btn-block btn-sm margin10T"
          onClick={() => onFilter({ selectedItem })}
        >
          {intl.formatMessage(messages.Filter)}
        </button>
        {isFiltered && (
          <button
            type="button"
            className="btn btn-default btn-sm margin10T"
            onClick={() => this.handleClear()}
          >
            <i className="fa fa-times" />
            &nbsp;
            <span>{intl.formatMessage(messages.ClearFilter)}</span>
          </button>
        )}
      </div>
    );
  }

  static propTypes = {
    initialValue: PropTypes.shape({}),
    /** Function to execute when a value has been entered and search has been requested */
    onFilter: PropTypes.func.isRequired,
    /** Boolean indicating whether a value is currently being filtered. Used for displaying a clear filter button  */
    isFiltered: PropTypes.bool,
    /** Function to execute when a user starts typing to search for values e.g. relations */
    loadFunc: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    initialValue: undefined,
    isFiltered: false,
  };
}

export default SelectFilter;
